import { createRouter, createWebHistory } from 'vue-router'
import processingvV2 from '../views/ProcessingV2.vue'
import NotificationManagementView from '../views/NotificationManagementView'
import DashboardShell from '../views/DashboardShell.vue'
import CommandCenter from '../views/CommandCenter.vue'
import DashboardViewV2 from '../views/DashboardViewV2.vue'


import PostCloseConnect from '../views/PostCloseConnect.vue'
import PostCloseConnectV2 from '../views/PostCloseConnectV2.vue'
import ApplicationsView from '../views/ApplicationsView'
import CondtionCommandView from '../views/ConditionCommand.vue'
import ConditionMain from '../components/conditionCommand/ConditionsDashboardMain.vue'
import Insights from '@/views/Insights.vue'
import LeaderboardView from '@/views/LeaderboardView.vue'
import RepricedLocksDashboard from '@/views/RepricedLocksDashboard.vue'
import RepriceApproval  from '@/views/Repriceapproval.vue'
import HmdaWithdrawalDashboard from '@/views/HmdaWithdrawalDashboard.vue'
import FhaMipPaymentsDashboard from '@/views/FhaMipPaymentsDashboard.vue'
import AiInsuringDashboard from '@/views/AiInsuringDashboard.vue'
import ReverseMortgageView from '@/views/ReverseMortgageView.vue'
import LockExtensionsDashboard from '@/views/LockExtensionsDashboard.vue'
import LockExtensionLanding from '@/views/LockExtensionLanding.vue'
import LoanPriceSheet from '@/views/LoanPriceSheet.vue'
import LockDeskQueue from '@/views/LockDeskQueue.vue'
import RevenueAnalysis from '@/views/RevenueAnalysis.vue'
import LockValidations from '@/views/LockValidations.vue'
import Concessions from '@/views/Concessions.vue'
import ConcessionRequest from '@/views/ConcessionRequest.vue'
import InitialDisclosureDashboard from '@/views/InitialDisclosureDashboard.vue'
import PccdDashboard from '@/views/PccdDashboard.vue'
import DisclosureAuditDashboard from '@/views/DisclosureAuditDashboard.vue'
import InsuringView from '@/views/InsuringView.vue'
import LoRedirect from '@/views/LoRedirect.vue'
import PollyPricerView from '@/views/PollyPricerView.vue'
import DebtConsolidationCalculator from '@/views/DebtConsolidationCalculator.vue'
import PaymentCalculator from '@/views/PaymentCalculator.vue'
import BuydownCalculator from '@/views/BuydownCalculator.vue'
import TurnTimesView from '@/views/TurnTimesView.vue'
import CashOutRefiWizard from '@/views/CashOutRefiWizard.vue'
import ScenarioBuilder from '@/views/ScenarioBuilder.vue'
// Insights pages ported from CGS2022, behind the insights flag (helpers/insights/insightPages.js).
import { insightRoutes } from './insightRoutes.js'
import { isConnectEnabled } from '@/helpers/connect/connectFeatures.js'

// Contacts tab (helpers/connect/connectFeatures.js). Lazy, so none of it loads until opened; the
// guard sends everyone to the Command Center while the connect flag is off.
const connectGuard = () => (isConnectEnabled() ? true : { path: '/' })
const connectRoutes = [
  { path: '/contacts', name: 'contacts', component: () => import(/* webpackChunkName: "connect" */ '../views/contacts/ContactsView.vue'), beforeEnter: connectGuard },
  { path: '/contacts/:id', name: 'contact', component: () => import(/* webpackChunkName: "connect" */ '../views/contacts/ContactDetailView.vue'), beforeEnter: connectGuard }
]

const routes = [
  ...insightRoutes,
  ...connectRoutes,
    {
    path: '/ICD',
    name: 'initialDisclosures',
    component: InitialDisclosureDashboard
  },
  {
    path: '/pccd',
    name: 'pccd',
    component: PccdDashboard
  },
  {
    path: '/disclosure-audit',
    name: 'disclosureAudit',
    component: DisclosureAuditDashboard
  },
  {
    path: '/loan-price-sheet',
    name: 'LoanPriceSheet',
    component: LoanPriceSheet
  },
  {
    // Calculators are standalone arithmetic tools -- no loanId, no API, no saved state. The
    // /calculators/* prefix is deliberate: isPathActive() matches on prefix, so the sidebar
    // group lights up for every calculator added under it without touching navConfig's logic.
    path: '/calculators/debt-consolidation',
    name: 'debtConsolidationCalculator',
    component: DebtConsolidationCalculator
  },
  {
    // Ported from CGS2022's Turn Times page. Ungated, as it was there.
    path: '/turn-times',
    name: 'turnTimes',
    component: TurnTimesView
  },
  {
    path: '/calculators/payment',
    name: 'paymentCalculator',
    component: PaymentCalculator
  },
  {
    // Ported from CGS2022's Buydown Calculator. Ungated, like the other calculators.
    path: '/calculators/buydown',
    name: 'buydownCalculator',
    component: BuydownCalculator
  },
  {
    path: '/calculators/cash-out-refi',
    name: 'cashOutRefiWizard',
    component: CashOutRefiWizard
  },
  {
    path: '/calculators/scenario-builder',
    name: 'scenarioBuilder',
    component: ScenarioBuilder
  },
  {
    // Opened in its own browser tab (sidebar button = Scenario Mode with no loanId, or a
    // pipeline row button = Lock Mode for that loan), so — like concessionRequest — this
    // needs a real URL rather than in-memory state.
    path: '/polly-pricer/:loanId?',
    name: 'pollyPricer',
    component: PollyPricerView,
    props: true
  },
  {
    path: '/lock-extension-request',
    name: 'LockExtensionLanding',
    component: LockExtensionLanding
  },
  {
    // The signed-in user's own locks, with the swiftLocks tools for each. Open to everyone; the
    // API scopes the rows to the caller's own loans.
    path: '/my-locks',
    name: 'myLocks',
    component: () => import('../views/MyLocks.vue')
  },
  {
    // The signed-in user's prequal letters (mine / my branch / all, scoped server side) and the
    // realtor link tools for each.
    path: '/swift-prequal',
    name: 'swiftPrequal',
    component: () => import('../views/SwiftPrequal.vue')
  },
  {
    // One prequal loan: its letter versions, realtorConnect link and the letters themselves.
    path: '/swift-prequal/:loanId',
    name: 'swiftPrequalDetail',
    component: () => import('../views/SwiftPrequalDetail.vue')
  },
  {
    path: '/lock-desk-queue',
    name: 'lockDeskQueue',
    component: LockDeskQueue
  },
  {
    path: '/revenue-analysis',
    name: 'revenueAnalysis',
    component: RevenueAnalysis
  },
  {
    path: '/validations',
    name: 'validations',
    component: LockValidations
  },
  {
    // Best investor price at each note rate against Village Capital's version (backlog 9219).
    // Lock desk only; the API refuses everyone else.
    path: '/pricing-comparison',
    name: 'pricingComparison',
    component: () => import('../views/PricingComparison.vue')
  },
  {
    path: '/concessions',
    name: 'concessions',
    component: Concessions
  },
  {
    // Opened in its own browser tab from the pipeline, so it needs a real URL rather
    // than in-memory state. No loanId = the manual path, for a loan the pipeline
    // cannot offer.
    path: '/concessions/request/:loanId?',
    name: 'concessionRequest',
    component: ConcessionRequest,
    props: true
  },
  {
    path: '/extensions',
    name: 'extensions',
    query: { id: '' },
    component: LockExtensionsDashboard
  },
  {
    path: '/reprice',
    name: 'reprice',
    query: { id: '' },
    component: RepricedLocksDashboard
  },
   {
    path: '/reprice-approval',
    name: 'repriceApproval',
    component: RepriceApproval
  },
  {
    path: '/processing',
    name: 'processing',
    query: { id: '' },
    component: processingvV2
  },
  {
    path: '/Processingv2',
    name: 'processingv2',
    query: { id: '' },
    component: processingvV2
  },
  {
    path: '/NotificationManagement',
    name: 'notificationManagement',
    component: NotificationManagementView
  },


  {
    path: '/',
    name: 'dashboard',
    component: DashboardShell
  },
  {
    path: '/commandcenter',
    name: 'commandcenter',
    component: CommandCenter
  },
  {
    path: '/dashboardv2',
    name: 'dashboardv2',
    component: DashboardViewV2
  }, 
  {
    path: '/PostCloseConnect',
    name: 'postCloseConnect',
    component: PostCloseConnectV2
  },
  {
    path: '/PostCloseConnectV2',
    name: 'postCloseConnectV2',
    component: PostCloseConnectV2
  },
  {
    path: '/Applications',
    name: 'applications',
    component: ApplicationsView
  },
  {
    path: '/ConditionCommand',
    name: 'condtionCommand',
    component: CondtionCommandView
  },
  {
    path: '/ConditionMain',
    name: 'ConditionMain',
    component: ConditionMain
  },
  ,
  {
    path: '/Insights',
    name: 'Insights',
    component: Insights
  },
  {
    // swiftUW Appraisal Review, beside /Insights in the swiftUW nav group. Not under /Insights/, or
    // isPathActive would match the Condition Insights child too. Corp only: Swift.API returns 403.
    path: '/AppraisalReview',
    name: 'appraisalReview',
    component: () => import('../views/AppraisalReview.vue')
  },
  {
    path: '/Leaderboard',
    name: 'Leaderboard',
    component: LeaderboardView
  },
  {
    path: '/hmda-withdrawals',
    name: 'hmdaWithdrawals',
    component: HmdaWithdrawalDashboard
  },
  {
    path: '/fha-mip-payments',
    name: 'fhaMipPayments',
    component: FhaMipPaymentsDashboard
  },
  {
    path: '/loans-funded',
    name: 'loansFunded',
    component: () => import('../views/LoansFundedDashboard.vue')
  },
  {
    path: '/ai-insuring',
    name: 'aiInsuring',
    component: AiInsuringDashboard
  },
  {
    path: '/reverse-mortgage',
    name: 'reverseMortgage',
    component: ReverseMortgageView
  },
  {
    path: '/Insuring',
    name: 'insuring',
    component: InsuringView
  },
  {
  path: '/application-commercial',
  name: 'CommercialLoan',
   component: () => import('../views/CommercialLoanView.vue'),
   meta: { requiresAuth: true }
  },
  {
    path: '/LORedirect',
    name: 'loRedirect',
    component: LoRedirect
  },
  {
    // My Profile — under the "Tools" nav group (was "Me") with My Website.
    path: '/my-profile',
    name: 'myProfile',
    component: () => import('../views/MyProfileView.vue')
  },
  {
    // swiftAnalyze — AI document screenings from GSAI_DocumentPipeline. Admin only: the page shows
    // its not-authorized card to anyone else, and GSWebAPIv2 returns 403 regardless.
    path: '/swift-analyze',
    name: 'swiftAnalyze',
    component: () => import('../views/SwiftAnalyzeDashboard.vue')
  },
  {
    // Purchase Agreement Import (9189) — read a purchase agreement and write its fields into Encompass.
    // Admin only while it is piloted: the page shows its not-authorized card to anyone else, and
    // GSWebAPIv2 returns 403 regardless. Lazy, so pdf.js only loads for this page.
    // Optional ?loanId= or ?loanNumber= opens it on that loan.
    // Moved to SWIFT SPA (/PurchaseAgreement): no nav link points here any more, only the URL.
    path: '/purchase-agreement-import',
    name: 'purchaseAgreementImport',
    component: () => import('../views/PurchaseAgreementImport.vue')
  },
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router